export default __webpack_public_path__ + "static/media/help-rav-v-3.aafe6c55.png";